import lodash from "lodash";
import { Decoration_Type } from "./../ricos-types";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { TEXT_COLOR_MODAL_ID, TEXT_HIGHLIGHT_MODAL_ID } from "./constants";
import { TEXT_BUTTON_TEXT_COLOR, TEXT_BUTTON_TEXT_HIGHLIGHT } from "./data-hooks";
import TextColorIcon from "./icons/TextColorIcon";
import TextHighlightIcon from "./icons/TextHighlightIcon";
import { TextColorPicker } from "./TextColorPicker";
const getTextColorTextButtons = (config = {}) => {
  return [
    {
      id: `${Decoration_Type.COLOR}.foreground`,
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_TEXT_COLOR,
        tooltip: "TextColorButton_Tooltip",
        getIcon(publicCommands) {
          const color = publicCommands.getColor("ricos-text-color");
          return () => TextColorIcon({ color });
        }
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        selectedTextColor: RESOLVERS_IDS.GET_TEXT_COLOR_IN_SELECTION,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      command: ({ referenceElement, clickFromKeyboard, modalService }) => () => {
        modalService.isModalOpen(TEXT_COLOR_MODAL_ID) ? modalService.closeModal(TEXT_COLOR_MODAL_ID) : openColorModal({
          modalId: TEXT_COLOR_MODAL_ID,
          modalType: "ricos-text-color",
          modalService,
          config,
          referenceElement,
          clickFromKeyboard: !!clickFromKeyboard
        });
        return true;
      }
    }
  ];
};
const getTextHighlightTextButtons = (config = {}) => {
  return [
    {
      id: `${Decoration_Type.COLOR}.background`,
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_TEXT_HIGHLIGHT,
        tooltip: "TextHighlightButton_Tooltip",
        getIcon(publicCommands) {
          const color = publicCommands.getColor("ricos-text-highlight");
          return () => TextHighlightIcon({ color });
        }
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        selectedHighlightColor: RESOLVERS_IDS.GET_HIGHLIGHT_COLOR_IN_SELECTION,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      command: ({ referenceElement, clickFromKeyboard, modalService }) => () => {
        modalService.isModalOpen(TEXT_HIGHLIGHT_MODAL_ID) ? modalService.closeModal(TEXT_HIGHLIGHT_MODAL_ID) : openColorModal({
          modalId: TEXT_HIGHLIGHT_MODAL_ID,
          modalType: "ricos-text-highlight",
          modalService,
          config,
          referenceElement,
          clickFromKeyboard: !!clickFromKeyboard
        });
        return true;
      }
    }
  ];
};
const openColorModal = ({
  modalId,
  modalType,
  modalService,
  referenceElement,
  config,
  clickFromKeyboard
}) => {
  modalService.openModal({
    id: modalId,
    Component: TextColorPicker,
    componentProps: {
      referenceElement,
      type: modalType,
      config
    },
    layout: {
      desktop: referenceElement ? "floating" : "dialog",
      mobile: "drawer"
    },
    noPadding: true,
    ...referenceElement && {
      positioning: { placement: "bottom", referenceElement }
    },
    onClickOutside: lodash.noop,
    returnFocusOnDeactivate: clickFromKeyboard,
    disableArrowNavigation: true,
    dragHandleSelector: "[data-drag-handler]",
    enableDrag: true,
    withTransition: true
  });
};
export {
  getTextColorTextButtons,
  getTextHighlightTextButtons,
  openColorModal
};
//# sourceMappingURL=getTextButtons.js.map
